// [TR-2087] - Used a forEach for all the below to catch any missing data that may be in normalisedRelationships but missing from normalisedData
import { ingredientTransformer } from 'apis/transformers/recipes/ingredientTransformer'

const allergensTransformer = (allergensArray) => {
  const contains = allergensArray.filter((allergen) => allergen.contain_type === 'contains')

  return contains.map((allergen) => allergen.name)
}

const basicsTransformer = (basicsArray) => basicsArray.map((basic) => basic.name)

const cropsTransformer = (media) =>
  media.map((url) => ({
    src: url.url,
    width: url.width,
  }))

const equipmentTransformer = (equipmentArray) => equipmentArray.map((piece) => piece.name)

const formatIngredients = (rawIngredients, normalisedIngredients) => {
  if (rawIngredients && normalisedIngredients) {
    return rawIngredients.reduce((result, rawIngredient) => {
      const ingredient = normalisedIngredients[rawIngredient.id]
      if (!ingredient) return result
      ingredient.quantities = rawIngredient.quantities
      result.push(ingredientTransformer(ingredient))

      return result
    }, [])
  }

  return []
}

const imageUrlMap = (urls) =>
  urls.map((url) => ({
    src: url.url,
    width: url.width,
  }))

const shelfLifeTransformer = (minDays, maxDays) => `${minDays}-${maxDays}`

const surchargeTransformer = (surcharge) => {
  if (!surcharge) return null
  const decimalSurcharge = surcharge.price.value / 100

  return {
    listPrice: decimalSurcharge,
  }
}

const isBlueyRecipeTransformer = (attributes) =>
  Boolean(attributes.food_brand && attributes.food_brand.slug === 'bluey')

const isFineDineInTransformer = (attributes) =>
  Boolean(attributes.food_brand && attributes.food_brand.slug === 'fine-dine-in')

const isNewTransformer = (debutRecipes, recipeId) => {
  if (debutRecipes && debutRecipes.data && debutRecipes.data.length) {
    return debutRecipes.data.some((recipe) => recipe.core_recipe_id === recipeId)
  }

  return false
}

export {
  allergensTransformer,
  basicsTransformer,
  cropsTransformer,
  equipmentTransformer,
  formatIngredients,
  imageUrlMap,
  shelfLifeTransformer,
  surchargeTransformer,
  isBlueyRecipeTransformer,
  isFineDineInTransformer,
  isNewTransformer,
}
